import { Container, Stack } from "@mui/material";
import { Page } from "../../../../components";
import HeaderBreadcrumbs from "../../../../components/header-breadcrumbs";
import { useParams } from "react-router-dom";
import { NewMessageComposeComponent } from "../../../../components/message-center/v2/send-a-message/new-message-compose-component";

export const EditAutomatedReminderConfigureScreen = () => {
    const { id } = useParams();

    return (
        <Page title="POM Safe - Edit Reminder">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Edit automated reminder"
                        links={[
                            { name: 'Message Center', href: '/messages' },
                            { name: 'Edit Recipients', href: `/messages/automated-reminders/${id}/edit/recipients` },
                            { name: 'Edit Configuration', href: `/messages/automated-reminders/${id}/edit/configure` },
                        ]}
                        activeLast={false}
                    />
                </Stack>

                <NewMessageComposeComponent mode="reminder" />
            </Container>
        </Page>
    )
}